module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "phone",
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "clear-phone",
    on: {
      "click": function($event) {
        _vm.phone = ''
      }
    }
  }), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.phoneValidate),
      expression: "!phoneValidate"
    }],
    staticClass: "tips"
  }, [_vm._v("请输入正确的手机号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    staticClass: "code",
    attrs: {
      "type": "text",
      "placeholder": "验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "get-code",
    attrs: {
      "disabled": _vm.phoneValidate && _vm.buttonText == '获取验证码' ? null : 'disabled'
    },
    on: {
      "click": function($event) {
        return _vm.getCode()
      }
    }
  }, [_vm._v(_vm._s(_vm.buttonText))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.codeValidate),
      expression: "!codeValidate"
    }],
    staticClass: "tips"
  }, [_vm._v("请输入正确的验证码")]), _vm._v(" "), _c('button', {
    staticClass: "login-btn",
    on: {
      "click": function($event) {
        return _vm.login()
      }
    }
  }, [_vm._v("登录")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-7a60ca18"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 547
// module chunks = 1